export const ANALYTICS_RESET_REDUX = 'ANALYTICS_RESET_REDUX'
export const ANALYTICS_RESET_MODULE = 'ANALYTICS_RESET_MODULE'
export const ANALYTICS_TOGGLE_LOADING = 'ANALYTICS_TOGGLE_LOADING'
export const ANALYTICS_TOGGLE_DATASETS = 'ANALYTICS_TOGGLE_DATASETS'
export const ANALYTICS_UPDATE_FIELD_VALUE = 'ANALYTICS_UPDATE_FIELD_VALUE'
export const ANALYTICS_UPDATE_DATASETS_FIELD_VALUE = 'ANALYTICS_UPDATE_DATASETS_FIELD_VALUE'

export const analyticsReset = () => ({
  type: ANALYTICS_RESET_REDUX
})

export const resetModule = (module) => ({
  type: ANALYTICS_RESET_MODULE,
  payload: { module }
})

export const toggleLoading = (module, loading = false) => ({
  type: ANALYTICS_TOGGLE_LOADING,
  payload: { module, loading }
})

export const updateDatasets = (module, datasets = {}) => ({
  type: ANALYTICS_TOGGLE_DATASETS,
  payload: { module, datasets }
})
export const updateDatasetsFieldValue = (module, field, value) => ({
  type: ANALYTICS_UPDATE_DATASETS_FIELD_VALUE,
  payload: { module, field, value }
})

export const updateFieldValue = (module, field, value) => ({
  type: ANALYTICS_UPDATE_FIELD_VALUE,
  payload: { module, field, value }
})
